import {LinePlotSettings} from '../../../components/WorkspaceDrawer/Settings/types';
import {ActionType, ViewReducerState} from '../reducerSupport';
import * as Actions from './actions';
import {Ref as WorkspaceSettingsRef} from './types';

export const disableAutoGeneratePanels = (
  state: ViewReducerState,
  ref: WorkspaceSettingsRef
): [ViewReducerState, ActionType] => {
  const newState = Object.assign({}, state);
  newState.parts = Object.assign({}, state.parts);
  newState.parts[ref.type] = Object.assign({}, state.parts[ref.type]);
  newState.parts[ref.type][ref.id] = Object.assign(
    {},
    state.parts[ref.type][ref.id],
    {shouldAutoGeneratePanels: false}
  );
  const inverseAction = Actions.enableAutoGeneratePanels(ref);
  return [newState, inverseAction];
};

// enable auto-gen requires using an existing util
// that's written with mutating logic, so we can't
// make it immutable unless that util is refactored
export const enableAutoGeneratePanels = (
  draft: ViewReducerState,
  ref: WorkspaceSettingsRef
): ActionType => {
  draft.parts[ref.type][ref.id].shouldAutoGeneratePanels = true;
  const inverseAction = Actions.disableAutoGeneratePanels(ref);
  return inverseAction;
};

export const updateLinePlotWorkspaceSettings = (
  state: ViewReducerState,
  ref: WorkspaceSettingsRef,
  settings: Partial<LinePlotSettings>
): [ViewReducerState, ActionType] => {
  const newState = {
    ...state,
    parts: {
      ...state.parts,
      [ref.type]: {
        ...state.parts[ref.type],
      },
    },
  };
  const prevWorkspaceSettings = newState.parts['workspace-settings'][ref.id];

  newState.parts['workspace-settings'][ref.id] = {
    ...prevWorkspaceSettings,
    linePlot: {
      ...prevWorkspaceSettings.linePlot,
      ...settings,
    },
  };

  const inverseAction = Actions.updateLinePlotWorkspaceSettings(
    ref,
    prevWorkspaceSettings.linePlot ?? {}
  );
  return [newState, inverseAction];
};
